<template>
    <div>
      <el-drawer @reload="$reloadHandle"
                 :title="'确认'" size="30%"
                 :before-close="handleClose"
                 :visible.sync="drawer"
                 direction="rtl"
                 :modal-append-to-body="true"
                 custom-class="demo-drawer"
                 ref="drawer" >


        <div class="demo-drawer__content">
            <div style="display: flex;margin: 10px 0;   font-size: 12px;    color: rgba(86, 86, 86, 0.96);">
                <span style="display: inline-block;width: 88px;text-align: right;">是否异议：</span>
                <el-radio-group style="margin-left: 15px;" v-model="formData.stat" @change="radioHandleChange">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
            </div>
          <el-form :model="formData" label-width="100px">
            <el-form-item label="异议说明" :rules="{required: true}">
              <el-input type="textarea"
                        :autosize="{ minRows: 2, maxRows: 8}"
                        v-model="formData.remark" :disabled="isRemark"
                        autocomplete="off"></el-input>
            </el-form-item>
            <div class="d-item">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                <div class="title first"><b>附件列表</b></div>
                <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                           :action="api.uploadFileUrl"  :show-file-list="false" :on-progress="upVideo"
                           :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :headers="headers"
                           :auto-upload="true">
                  <el-button type="primary" class="button-sty btn_zdy">
                    <i class="el-icon-plus"></i>
                    附件
                  </el-button>
                </el-upload>
              </div>
              <div>
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                           @checkbox-all="selectChangeEvent" :data="fileList">
                  <vxe-column type="checkbox" width="40" />
                  <vxe-column field="fileName" title="附件名称" width="400">
                    <template #default="{ row }">
                      <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a>
                    </template>
                  </vxe-column>
                  <vxe-column title="操作" width="60">
                    <template #default="{ row }">
                      <div @click="deleteFile(row)">
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
            </div>
          </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
            bottom: 5px; right: 5px;">
            <el-button @click="cancelForm">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
          </div>
        </div>
      </el-drawer>

    </div>
  </template>
  <script>

  import api from "@/api/projectApi";
  // 文件上传
import textUpload from "@/components/formItem/textUpload.vue"
  import store from "@/store";
  export default {
    inject: ['reload'],
    name: 'edit',
    props: ['id','stat','remark'],
    components: {textUpload},
    created() {
      console.log('askdfksdfk', this.id)
      this.formData.id = this.id
      this.formData.stat = this.stat
      this.formData.remark = this.remark
    },
    computed: {

      api() {
        return api
      },
      headers: function () {
        const tenantId = store.getters.userInfo.tenantId
        return {
          'Authorization': "Bearer " + store.getters.access_token,
          'TENANT-ID': tenantId
        };
      }

    },
    data() {
      return {
        fileList: [],
        blow: [],

        formData: {
          remark: null,
          stat: null,
          id: null,
          type: null,
          sfBatchSettleFileList: [],
        },
        drawer: true,
        isRemark: true,
        // radioHandle: "",
      }
    },
    methods: {
      // 确定
      confirm() {
        // this.$validate(this.formData,
        //   {remark: [{required: true, prop: '异议意见', maxlength: 100, type: 'string'}]}
        // ).then(() => {

        // if (this.blow && this.blow[0]) {
        //   this.formData.annexFileName = this.blow[0].name
        //   this.formData.annexFile = this.blow[0].url
        // }
          this.formData.sfBatchSettleFileList = this.fileList
          this.$http({
            url: api.sfBatchSettle.settleConfirmDataUrl,
            method: 'post',
            data: this.formData
          }).then(res => {
            this.$message.success('操作成功')
            this.visiable = false
            this.$emit('update:visiable', this.visiable)
            this.$emit('goBackIndex')
          })
        // })
      },

      deleteFile(row) {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          console.log(row, 'delete')
          this.fileList = this.fileList.filter(item => item.url !== row.url)
        })
      },

      selectChangeEvent(data) {
        console.log('选中数据', data)
        this.selectedData = data.records
      },

      radioHandleChange(val) {
        this.radioHandle = val
        if (val == 1) { //异议
          this.isRemark = false
        }else  if (val == 2) { //确认
          this.formData.remark = "";
          this.isRemark = true
        }
      },

      handleFileSuccess(res, file, fileList) {
        let url = res.data.url
        let fileName = file.name
        console.log(url, "url")
        console.log(fileName, "name")
        this.fileList.push({
          fileName: fileName,
          fileUrl: url
        })
        this.$mask.close()

      },
      // confirm() {
      //   this.drawer = false;
      //   this.handleClose()
      // },
      cancelForm() {
        this.visiable = false
        this.$emit('update:visiable', this.visiable)
      },
      handleClose() {
        this.cancelForm()
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  ::v-deep .el-textarea{
width: 70%;
  }
  </style>
